
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
} from "@mui/material";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { t } from "i18next";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { getLocalStorageMenuItem, setMobileTextColor } from "../../utility";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Reverse geocode helper function
const reverseGeocode = async (lat, lng) => {
  const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`;
  const res = await fetch(url);
  const data = await res.json();
  return data.address;
};

export default function CurrentLocationMap({ openLocationFormDailog, latlangVal, updateLocationFormData, closeMapModal }) {
  const [location, setLocation] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const coords = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        setLocation(coords);

        try {
          const addr = await reverseGeocode(coords.lat, coords.lng);
          updateLocationFormData(addr);
        } catch (err) {
          console.error("Reverse geocoding failed:", err);
        }
      },
      (err) => {
        setError(err.message || "Could not get location.");
        console.error(err);
      }
    );
  }, []);

  const handleOpenLocationFormDailog = () => {
    openLocationFormDailog();

    latlangVal(location);
  };

  return (
    <Box >
      <IconButton
        color={setMobileTextColor()}
        onClick={closeMapModal}
        sx={[{ position: "absolute", top: 8, color: setMobileTextColor() }

          , getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fr" ? {
            left: 1
          } : {
          right: 1
        }
        ]}
      >
        <CloseIcon />
      </IconButton>
      <Typography className="head-font" variant="h6" gutterBottom>
        📍 {t("Current Location")}
      </Typography>

      {location ? (
        <>
          <MapContainer

            center={[location.lat, location.lng]}
            zoom={15}
            style={{ height: "400px", width: "100%", borderRadius: 2 }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={[location.lat, location.lng]}>
              <Popup>{t("You are here")}</Popup>
            </Marker>
          </MapContainer>

          {location && (
            <Box mt={2} textAlign="center">
              <Button
                className="head-font"
                variant="contained"
                color="primary"
                onClick={handleOpenLocationFormDailog}
              >
                {t("Continue")}
              </Button>
            </Box>
          )}

        </>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <Typography>{t("Loading location...")} </Typography>
      )}
    </Box>
  );
}




